import { densityUnits, max, xUnits } from '../../../UNSAFE_Theme/utils';
import { typographyVars } from '@oracle/oraclejet-internal-theme-contract/themeContract.css';
import { baseVars } from '@oracle/oraclejet-internal-theme-contract/themeContract.css';

export const scaleSchemeLg = {
  borderRadius: baseVars.borderRadius.md,
  fontSize: typographyVars.body.sm.fontSize,
  sizes: {
    xs: {
      textToEdgePadding: xUnits(4),
      // 24px x 24px is the minimum size per WCAG Success Criterion 2.5.8 Target Size (Minimum)
      height: max(`calc(${xUnits(6)} + ${densityUnits(3)})`, '24px')
    },
    sm: {
      textToEdgePadding: xUnits(4),
      // 24px x 24px is the minimum size per WCAG Success Criterion 2.5.8 Target Size (Minimum)
      height: max(`calc(${xUnits(9)} + ${densityUnits(3)})`, '24px')
    },
    md: {
      textToEdgePadding: xUnits(4),
      height: `calc(${xUnits(11)} + ${densityUnits(2)})`
    },
    lg: {
      textToEdgePadding: xUnits(6),
      height: `calc(${xUnits(13)} + ${densityUnits(2)})`
    }
  }
};
